import { useSelector } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { useState } from 'react';

import './Calendar.css';

const today = new Date();



function theCorrectMod(v, n) {
    return ((v % n) + n) % n;
}

function sameDay(d1, d2) {
    return d1.getFullYear() === d2.getFullYear() &&
      d1.getMonth() === d2.getMonth() &&
      d1.getDate() === d2.getDate();
}

function Calendar({ DayRenderer }) {

    const [ date, setDate ] = useState(new Date( today.getFullYear(), today.getMonth(), 1 ));

    const daysInMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
    const blankFirstDays = theCorrectMod(new Date(date.getFullYear(), date.getMonth(), 1).getDay() - 1, 7);
    const calendarLinesInMonth = Math.ceil((daysInMonth + blankFirstDays) / 7);

    function renderDay(dayOfMonth) {
        const isToday = sameDay(today, new Date(date.getFullYear(), date.getMonth(), dayOfMonth + 1 ));
        const isPast = new Date(date.getFullYear(), date.getMonth(), dayOfMonth + 1 ).getTime() < today.getTime();

        return (
            <td>
                <div className="column g4" style={{ padding: 4 }}>
                    <p style={{ padding: 4, fontWeight: '700', fontSize: 18, color: isToday ? 'white' : (isPast ? '#aaa' : 'black'), backgroundColor: isToday ? 'black' : 'white', width: 'fit-content', borderRadius: 4, paddingInline: isToday ? 8 : 4 }}>
                        {dayOfMonth + 1}
                    </p>

                    <DayRenderer date={new Date(date.getFullYear(), date.getMonth(), dayOfMonth + 1 )} />
                </div>
            </td>
        )
    }

    function renderLine(lineNr) {
        // renderDayFn of type: fn(cellNr)
        let renderDayFn = renderDay;

        if(lineNr == 0) {
            const oldRenderDayFn = renderDayFn;
            renderDayFn = (cellNr) => (cellNr < blankFirstDays) ? (<td style={{ backgroundColor: '#f8f8f8' }}></td>) : oldRenderDayFn(cellNr - blankFirstDays);
        } else if(lineNr == calendarLinesInMonth - 1) {
            const oldRenderDayFn = renderDayFn;
            renderDayFn = (cellNr) => (cellNr >= (blankFirstDays + daysInMonth)) ? (<td style={{ backgroundColor: '#f8f8f8' }}></td>) : oldRenderDayFn(cellNr - blankFirstDays);
        } else {
            const oldRenderDayFn = renderDayFn;
            renderDayFn = (cellNr) => oldRenderDayFn(cellNr - blankFirstDays);
        }

        // renderDayFn is now of type: fn(dayOfMonth)

        let elements = [];
        elements.length = 7;

        for(let i = 0; i < 7; i++) {
            elements.push(renderDayFn(lineNr * 7 + i));
        }

        return (
            <tr>
                {elements}
            </tr>
        );
    }

    function renderAllLines() {
        let elements = [];
        elements.length = 7;

        for(let i = 0; i < calendarLinesInMonth; i++) {
            elements.push(renderLine(i));
        }

        return elements;
    }
    

    return (
        <div id='calendar' className="column g32 screen center-cross">

            <div className="column g32" style={{ width: '100%', height: '100%' }}>

                <div className="row g16 center-cross">
                    <h1>Kalender</h1>

                    <div className="column">
                        <p>{[ "Jaanuar", "Veebruar", "Märts", "Aprill", "Mai", "Juuni", "Juuli", "August", "September", "Oktoober", "November", "Detsember" ][date.getMonth()]}</p>
                        <p>{date.getFullYear()}</p>
                    </div>

                    <div style={{ flex: 1 }}></div>

                    <div className="row g8 center-cross" style={{ padding: 8, border: 'solid 1px #ddd' }}>
                        <button onClick={() => { date.setMonth(date.getMonth() - 1); setDate(new Date(date)); } }>{"<"}</button>
                        <button onClick={() => { date.setMonth(date.getMonth() + 1); setDate(new Date(date)); } }>{">"}</button>
                    </div>
                </div>

                
                <table style={{ flex: 1 }}>
                    <thead>
                        <tr>
                            <th>E</th>
                            <th>T</th>
                            <th>K</th>
                            <th>N</th>
                            <th>R</th>
                            <th>L</th>
                            <th>P</th>
                        </tr>
                    </thead>
                    <tbody>
                        { renderAllLines() }
                    </tbody>
                </table>

            </div>

        </div>
    )
};

export default Calendar;